import { Injectable } from '@angular/core'
import { CommonService } from '../../shared/services/common.service'

@Injectable({
  providedIn: 'root',
})
export class HelpService {
  constructor(public commonService: CommonService) {}

  fetchVideoLinkResponse() {
    const urlParam = ['cms', 'components', 'VideoLink']
    // https://devstore.ibhge.com/occ/v2/vsstore/cms/components/VideoLink?fields=DEFAULT
    const apiParams = {
      fields: 'DEFAULT',
    }
    const url = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(url, apiParams)
  }

  fetchTrainingLinkResponse() {
    const urlParam = ['cms', 'components', 'UserManual']
    // https://devstore.ibhge.com/occ/v2/vsstore/cms/components/UserManual?fields=DEFAULT
    const apiParams = {
      fields: 'DEFAULT',
    }
    const url = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(url, apiParams)
  }
}
